import React from "react";
import { Table } from "react-bootstrap";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";

const GAD7Interpretation = () => {
  return (
    <div className={styles["interpretation"]}>
      <div className={styles["interpretation__title"]}>
        GAD-7 Interpretation:
      </div>

      <div className={styles["interpretation__text"]}>
        <b>
          When screening for anxiety disorders, a score of 8 or greater
          represents a reasonable cut-point for identifying probable cases of
          generalized anxiety disorder;
        </b>{" "}
        further diagnostic assessment is warranted to determine the presence and
        type of anxiety disorder. Using a cut-off of 8 the GAD-7 has a
        sensitivity of 92% and specificity of 76% for diagnosis generalized
        anxiety disorder. <sup>2,3</sup>
      </div>
      <br />
      <div className={styles["interpretation__text"]}>
        The following cut-offs correlate with level of anxiety severity{" "}
        <sup>2</sup>.
      </div>
      <div className={styles["interpretation__score"]}>
        <ul>
          <li>
            Score <b>0-4: Minimal Anxiety</b>
          </li>
          <li>
            Score <b>5-9: Mild Anxiety</b>
          </li>
          <li>
            Score <b>10-14: Moderate Anxiety</b>
          </li>
          <li>
            Score{" "}
            <b>
              greater than 15: <span className={"red"}>Severe Anxiety</span>
            </b>
          </li>
        </ul>
      </div>
      <div className={getClasses("mt-3", styles["interpretation__text"])}>
        Based on a recent meta-analysis, some experts have recommended
        considering using a cut-off of 8 in order to optimize sensitivity
        without compromising specificity. <sup>2</sup>
      </div>
      <hr />
      <div className={styles["interpretation__title"]}>
        Performing as Screening Tool for Anxiety Disorders
      </div>
      <div className={getClasses("mb-3", styles["interpretation__text"])}>
        Although designed as a screening tool for generalized anxiety, the GAD-7
        is also performs reasonably well as a screening tool for three other
        common anxiety disorders—Panic Disorder, Social Anxiety Disorder, and
        Post-traumatic Stress Disorder. <sup>3</sup>
      </div>

      <Table className={styles["interpretation__table"]} size="sm">
        <thead>
          <tr>
            <th
              className={styles["interpretation__table-title-th"]}
              colSpan={6}
            >
              Performance of GAD-7 as Screening Tool for Anxiety Disorders3
              (Using GAD-7 Score Cut-off of ≥10)
            </th>
          </tr>
          <tr className={styles["interpretation__table-second-tr"]}>
            <th></th>
            <th>Test</th>
            <th>Sensitivity</th>
            <th>Specificity</th>
            <th>Positive Likelihood Ratio</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td>Generalized Anxiety Disorder</td>
            <td>89%</td>
            <td>82%</td>
            <td>5.1</td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td>Panic Disorder</td>
            <td>74%</td>
            <td>81%</td>
            <td>3.9</td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td>Social Anxiety Disorder</td>
            <td>72%</td>
            <td>80%</td>
            <td>3.6</td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td>Post Traumatic Stress Disorder</td>
            <td>66%</td>
            <td>81%</td>
            <td>3.5</td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td>Any anxiety disorder</td>
            <td>68%</td>
            <td>88%</td>
            <td>5.5</td>
            <td></td>
          </tr>
        </tbody>
      </Table>

      <hr />
      <div className={"bd-12"}>Source</div>
      <br />
      <div className={styles["interpretation__footnote"]}>
        <ol>
          <li>
            Spitzer RL, Kroenke K, Williams JB, Löwe B. A brief measure for
            assessing generalized anxiety disorder: the GAD-7. Arch Intern Med.
            2006;166:1092-7.
          </li>
          <li>
            Plummer F, Manea L, Trepel D, McMillan D. Screening for anxiety
            disorders with the GAD-7 and GAD-2: a systematic review and
            diagnostic metaanalysis. Gen Hosp Psychiatry. 2016;39:24-31.
          </li>
          <li>
            Kroenke K, Spitzer RL, Williams JB, Monahan PO, Löwe B. Anxiety
            disorders in primary care: prevalence, impairment, comorbidity, and
            detection. Ann Intern Med. 2007;146:317-25.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default GAD7Interpretation;
